import React, { useState } from 'react';
import Icon from '../../components/AppIcon';
import PromoCodeForm from './components/PromoCodeForm';
import PromoCodesTable from './components/PromoCodesTable';
import LoyaltyTiers from './components/LoyaltyTiers';
import CampaignsPanel from './components/CampaignsPanel';
import PromotionsAnalytics from './components/PromotionsAnalytics';

const TABS = [
  { id: 'promo-codes', label: 'Promo Codes', icon: 'Tag' },
  { id: 'loyalty', label: 'Loyalty Program', icon: 'Trophy' },
  { id: 'campaigns', label: 'Campaigns', icon: 'Megaphone' },
  { id: 'analytics', label: 'Analytics', icon: 'BarChart2' },
];

const PromotionsEngineScreen = () => {
  const [activeTab, setActiveTab] = useState('promo-codes');
  const [tableRefresh, setTableRefresh] = useState(0);

  const handlePromoCreated = () => setTableRefresh(r => r + 1);

  return (
    <div className="min-h-screen" style={{ background: '#f8f9fc' }}>
      {/* Header */}
      <div className="sticky top-0 z-30 border-b border-gray-200" style={{ background: 'linear-gradient(135deg, #0f2044 0%, #1a3a6e 100%)' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ background: 'rgba(212,175,55,0.2)' }}>
                <Icon name="Percent" size={20} color="#D4AF37" />
              </div>
              <div>
                <h1 className="text-lg font-bold text-white">Promotions Engine</h1>
                <p className="text-xs text-blue-200">Manage promo codes, loyalty & campaigns</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 rounded-lg" style={{ background: 'rgba(255,255,255,0.1)' }}>
                <div className="w-1.5 h-1.5 rounded-full bg-green-400" />
                <span className="text-xs text-white font-medium">Engine Active</span>
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div className="flex gap-1 pb-0 overflow-x-auto scrollbar-hide">
            {TABS?.map(tab => (
              <button
                key={tab?.id}
                onClick={() => setActiveTab(tab?.id)}
                className={`flex items-center gap-2 px-4 py-3 text-sm font-medium whitespace-nowrap border-b-2 transition-all duration-200 ${
                  activeTab === tab?.id
                    ? 'border-yellow-400 text-white' :'border-transparent text-blue-200 hover:text-white hover:border-blue-300'
                }`}
              >
                <Icon name={tab?.icon} size={15} />
                {tab?.label}
              </button>
            ))}
          </div>
        </div>
      </div>
      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {activeTab === 'promo-codes' && (
          <div className="space-y-6">
            {/* Summary Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {[
                { label: 'Create & manage discount codes', icon: 'Tag', color: '#0f2044' },
                { label: 'Set expiry dates & usage limits', icon: 'Clock', color: '#D4AF37' },
                { label: 'Target rides, deliveries or both', icon: 'Layers', color: '#3b82f6' },
                { label: 'Track real-time redemptions', icon: 'TrendingUp', color: '#10b981' },
              ]?.map(item => (
                <div key={item?.label} className="bg-white rounded-2xl border border-gray-200 shadow-sm p-4 flex items-center gap-3">
                  <div className="w-8 h-8 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: item?.color + '15' }}>
                    <Icon name={item?.icon} size={16} style={{ color: item?.color }} />
                  </div>
                  <p className="text-xs text-gray-600 leading-snug">{item?.label}</p>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
              <div className="xl:col-span-1">
                <PromoCodeForm onSuccess={handlePromoCreated} />
              </div>
              <div className="xl:col-span-2">
                <PromoCodesTable refreshTrigger={tableRefresh} />
              </div>
            </div>
          </div>
        )}

        {activeTab === 'loyalty' && <LoyaltyTiers />}
        {activeTab === 'campaigns' && <CampaignsPanel />}
        {activeTab === 'analytics' && <PromotionsAnalytics />}
      </div>
    </div>
  );
};

export default PromotionsEngineScreen;
